module.exports = __webpack_public_path__ + "static/media/gamesPlayed_50000_100000.784bf17e.png";